import { useScript } from "@bokio/hooks/useScript/useScript";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { useApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";
import { useUser } from "@bokio/shared/state/requests";

export const HubspotSupportChat = () => {
	const { companyInfo } = useCompanyInfo();
	const companyId = companyInfo.Id;
	const { user } = useUser();

	useScript(window.config.hubSpotLiveChat?.liveChatPortalId && "scripts/hubspotChatWidget.js");

	// eslint-disable-next-line react-hooks/immutability -- SS 2025-10-13 This lint error should be fixed in the future. Existing usages were disabled just to simplify merging lint rules upgrade.
	window.hsConversationsSettings = { loadImmediately: false };

	const loadWidget = (hubSpotConversations: NonNullable<typeof window.HubSpotConversations>, visitorToken?: string) => {
		if (visitorToken) {
			if (!user) {
				throw new Error("User is undefined");
			}
			window.hsConversationsSettings = {
				identificationEmail: user.Email,
				identificationToken: visitorToken,
			};
		}
		hubSpotConversations.widget.load();
	};

	useApi(proxy.Settings.HelpController.GetLiveChatInfo.Get, [companyId], {
		onSuccess: data => {
			const visitorToken = data.HubSpotVisitorToken;
			if (window.HubSpotConversations) {
				loadWidget(window.HubSpotConversations, visitorToken);
			} else {
				window.hsConversationsOnReady = [
					() => {
						if (!window.HubSpotConversations) {
							throw new Error("HubSpot Conversations not loaded");
						}
						loadWidget(window.HubSpotConversations, visitorToken);
					},
				];
			}
		},
	});

	return <></>;
};
